import React, { createContext, useContext, useState, useEffect } from "react";
import axiosInstance from "../api/axiosInstance";

const CustomerContext = createContext();
export const useCustomer = () => useContext(CustomerContext);

export const CustomerProvider = ({ children }) => {
  const [customer, setCustomer] = useState(null);
  const [loading, setLoading] = useState(true);

  // Підтягуємо профіль при старті
  const fetchProfile = async () => {
    try {
      setLoading(true);
      const res = await axiosInstance.get("/customers/me");
      setCustomer(res.data);
    } catch {
      setCustomer(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProfile();
  }, []);

  // Авторизація (логін)
  const login = async (email, password) => {
    await axiosInstance.post("/customers/login", { email, password });
    await fetchProfile();
  };

  const loginWithGoogle = async (googleToken) => {
    const payload =
      typeof googleToken === "string" ? { credential: googleToken } : googleToken;
    const res = await axiosInstance.post("/customers/google", payload);
    await fetchProfile();
    return res.data;
  };

  // Вихід
  const logout = async () => {
    try {
      await axiosInstance.post("/customers/logout");
    } catch (error) {
      console.error("Customer logout failed:", error);
    } finally {
      setCustomer(null);
      localStorage.removeItem("checkoutData"); // ← очищаємо форму!
    }
  };

  // Форс-оновлення (наприклад, після змін у профілі/адресах)
  const refreshCustomer = fetchProfile;

  return (
    <CustomerContext.Provider
      value={{
        customer,
        loading,
        login,
        loginWithGoogle,
        logout,
        setCustomer,
        refreshCustomer,
      }}
    >
      {children}
    </CustomerContext.Provider>
  );
};
